import React, { useState } from 'react';

import GeneralRiskStatusesTableEditRow from './GeneralRiskStatusesTableEditRow';
import GeneralRiskStatusesTableRow from './GeneralRiskStatusesTableRow';

export default function GeneralRiskStatusesTable(props) {
    const [editableStatus, setEditableStatus] = useState(null);

    const prepareUpdateUrl = (status) => {
        return props.updateUrl.replace('STATUS_ID', status.id);
    };

    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th className="tw-p-4 tw-w-40">{$t('Status')}</th>
                        <th className="tw-p-4">{$t('Description')}</th>
                        <th className="tw-p-4 tw-w-44">{$t('Actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {!props.isLoading &&
                        !!props.statuses?.length &&
                        props.statuses.map((status) => {
                            if (editableStatus && parseInt(editableStatus.id) === parseInt(status.id)) {
                                return (
                                    <GeneralRiskStatusesTableEditRow
                                        key={status.id}
                                        status={status}
                                        updateUrl={prepareUpdateUrl(status)}
                                        onUpdated={props.fetch}
                                        onCancel={() => setEditableStatus(null)}
                                    />
                                );
                            } else {
                                return (
                                    <GeneralRiskStatusesTableRow
                                        key={status.id}
                                        status={status}
                                        onEdit={() => setEditableStatus(status)}
                                        onDelete={() => props.onDelete(status)}
                                    />
                                );
                            }
                        })}
                    {props.isLoading && (
                        <tr>
                            <td colSpan="100" className="tw-p-4">
                                {$t('Loading')}...
                            </td>
                        </tr>
                    )}
                    {!props.isLoading && !props.statuses?.length && (
                        <tr>
                            <td colSpan="100" className="tw-p-4">
                                {$t('No Statuses found')}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
